import { Box, Placeholder } from '@stitch-fix/mode-react';
const GalleryItemLoadingPlaceholder = () => {
  return <Box p={1}>
      <Box mb={1}>
        <Placeholder width="100%" height="400px" variant="rect" />
      </Box>
      <Box style={{
      display: 'flex',
      gap: '1rem'
    }}>
        <Placeholder width={4} height={6} variant="rect" />
        <Placeholder width={4} height={6} variant="rect" />
      </Box>
    </Box>;
};
export default GalleryItemLoadingPlaceholder;